import { useState } from 'react';
import { BsX } from 'react-icons/bs';
import { SimpleButton } from '../../../../components/buttons/SimpleButton';
import './CourseChildConfirmation.css';

interface CourseChildConfirmationProps {
  hideOverlay: () => void;
  addChild: () => void;
  registerChild?: () => void;
}

const CourseChildConfirmation: React.FC<CourseChildConfirmationProps> = ({
                                                                             hideOverlay,
                                                                             addChild,
                                                                             registerChild
                                                                         }) => {
    const [registering, setRegistering] = useState(false);

    const handleRegister = () => {
        if (registering || !registerChild) return;
        setRegistering(true);
        registerChild();
    };

    return (
        <div className="p-2">
            <div className="d-flex align-items-center justify-content-between">
                <span className="fw-bold text-info h2">Success!</span>
                <BsX
                    size={32}
                    className="clickable"
                    style={{ color: '#5E646980' }}
                    onClick={hideOverlay}
                    aria-label="Close"
                />
            </div>
            <p className="confirmation-message">
                Your child is added to your account! What would you like to do next?
            </p>
            <div className="course-child-confirmation-actions">
                <SimpleButton
                    type="button"
                    variant="outline-primary"
                    className="w-100"
                    truncate={false}
                    onClick={addChild}
                    disabled={registering}
                >
                    Add Another Child
                </SimpleButton>
                <SimpleButton
                    type="button"
                    variant="primary"
                    className="w-100"
                    truncate={false}
                    onClick={handleRegister}
                    disabled={registering}
                >
                    {registering ? 'Registering...' : 'Continue Registration'}
                </SimpleButton>
            </div>
        </div>
    );
};

export default CourseChildConfirmation;
